import { ViewPopup } from '../ViewPopup.ts';
import { createDivIn, createExternalImgIn, createImgIn, createSpanIn, setElementInnerHTML, setElementOnClick } from '../../ui_utils/DomUtils.ts';
import { LobbyImage } from '@colonist/types';
import { UIAPIEndpoints } from '../../network/UIAPIEndpoints.ts';
import { CA } from '../../analytics/Analytics.ts';
import { navigateToPage } from '../../ui_utils/ClientUtils.ts';
import { StorageWrapper } from '../../StorageWrapper.ts';
import { AudioManager, AudioType } from '@colonist/audio';
import { ClientUserState } from '../../ClientUserState.ts';
import { sendGuestPopupContinueAsGuest, sendGuestPopupLoginClicked, sendGuestPopupShown } from '../../analytics/sendGuestPopupAnalytic.ts';
import { LoginProviderEnum } from '../../../../../shared/entity_datas/EntityDatas.ts';
import LogoMobile from '@static/images/logo_mobile.svg';
import BackgroundOverlay from '@static/images/landing_page_background_overlay_mobile.png';
import GoogleIcon from '@static/images/icon_google_color.svg';
import DiscordIcon from '@static/images/icon_discord_color.svg';
const LOGIN_FEATURES = [
    {
        image: LobbyImage.IconSwords,
        textKey: 'strings:popups.login.features.playRanked'
    },
    {
        image: LobbyImage.Memberships,
        textKey: 'strings:popups.login.features.trackProgress'
    },
    {
        image: LobbyImage.Avatars,
        textKey: 'strings:popups.login.features.challengeFriends'
    }
];
export class ViewPopupLogin extends ViewPopup {
    createLoginButtons() {
        var _ClientUserState_userState;
        ViewPopupLogin.createLoginProviderButtons(this.loginButtonsDiv, this.callbackHash, this.popupSource);
        if (this.ssoMode) {
            if (this.onCancel) ViewPopupLogin.createCancelButton(this.loginButtonsDiv, this.onCancel);
            return;
        }
        if ((_ClientUserState_userState = ClientUserState.userState) === null || _ClientUserState_userState === void 0 ? void 0 : _ClientUserState_userState.isLoggedIn) return;
        ViewPopupLogin.createContinueAsGuestButton(this.loginButtonsDiv, this, this.popupSource);
    }
    static buildLoginPopupBody(popup, options) {
        popup.contentContainer.classList.add('popup-login');
        popup.body.className = 'popup-login-body';
        createExternalImgIn(popup.body, BackgroundOverlay, {
            key: 'strings:colonistCommon.utils.emptyString'
        }, 'popup-login-background-overlay');
        createExternalImgIn(popup.body, LogoMobile, {
            key: 'strings:colonistCommon.utils.emptyString'
        }, 'login-logo');
        const taglineKey = (options === null || options === void 0 ? void 0 : options.ssoMode) ? 'strings:popups.login.noltSsoMessage' : 'strings:popups.login.tagline';
        createSpanIn(popup.body, 'login-tagline', {
            key: taglineKey
        });
        if (!(options === null || options === void 0 ? void 0 : options.ssoMode)) {
            const featuresDiv = createDivIn(popup.body, 'login-features');
            for (const feature of LOGIN_FEATURES){
                const featureDiv = createDivIn(featuresDiv, 'login-feature-item');
                createImgIn(featureDiv, feature.image);
                createSpanIn(featureDiv, '', {
                    key: feature.textKey
                });
            }
        }
        return createDivIn(popup.body, 'popup-login-wrapper');
    }
    static createContinueAsGuestButton(container, popup, popupSource) {
        const continueAsGuest = createDivIn(container, 'popup-login-btn popup-login-continue-btn');
        createSpanIn(continueAsGuest, 'popup-login-continue-btn-text', {
            key: 'strings:popups.login.continueAsGuest'
        });
        setElementOnClick(continueAsGuest, ()=>{
            AudioManager.play(AudioType.Click);
            if (popupSource != null) sendGuestPopupContinueAsGuest(popupSource);
            popup.removePopup();
        });
    }
    static createCancelButton(container, onCancel) {
        const cancelBtn = createDivIn(container, 'popup-login-btn popup-login-continue-btn');
        createSpanIn(cancelBtn, 'popup-login-continue-btn-text', {
            key: 'strings:colonistCommon.buttons.cancel'
        });
        setElementOnClick(cancelBtn, ()=>{
            AudioManager.play(AudioType.Click);
            onCancel();
        });
    }
    static createLoginProviderButtons(container, callbackHash, popupSource) {
        const googleLogin = createDivIn(container, 'popup-login-btn login-btn-provider');
        createExternalImgIn(googleLogin, GoogleIcon, {
            key: 'strings:colonistCommon.utils.emptyString'
        }, 'google-icon');
        createSpanIn(googleLogin, '', {
            key: 'strings:popups.login.continueWith',
            options: {
                context: 'google'
            }
        });
        const discordLogin = createDivIn(container, 'popup-login-btn login-btn-provider');
        createExternalImgIn(discordLogin, DiscordIcon, {
            key: 'strings:colonistCommon.utils.emptyString'
        }, 'discord-icon');
        createSpanIn(discordLogin, '', {
            key: 'strings:popups.login.continueWith',
            options: {
                context: 'discord'
            }
        });
        const appleLogin = createDivIn(container, 'popup-login-btn login-btn-provider');
        createImgIn(appleLogin, LobbyImage.AppleIcon);
        createSpanIn(appleLogin, '', {
            key: 'strings:popups.login.continueWith',
            options: {
                context: 'apple'
            }
        });
        setElementOnClick(googleLogin, ViewPopupLogin.createLoginClickHandler(UIAPIEndpoints.googleAuth(callbackHash), popupSource != null ? {
            source: popupSource,
            provider: LoginProviderEnum.Google
        } : undefined));
        setElementOnClick(discordLogin, ViewPopupLogin.createLoginClickHandler(UIAPIEndpoints.discordAuth(callbackHash), popupSource != null ? {
            source: popupSource,
            provider: LoginProviderEnum.Discord
        } : undefined));
        setElementOnClick(appleLogin, ViewPopupLogin.createLoginClickHandler(UIAPIEndpoints.appleAuth(callbackHash), popupSource != null ? {
            source: popupSource,
            provider: LoginProviderEnum.Apple
        } : undefined));
    }
    static getCallbackHashFromUrl() {
        const hash = window.location.hash;
        if (!hash) return undefined;
        if (hash.length <= 1) return undefined;
        return hash.substring(1);
    }
    static createLoginClickHandler(url, guestPopupClick) {
        return ()=>{
            AudioManager.play(AudioType.Click);
            CA.sendGoogleTagManagerEvent(CA.GoogleTagManagerEvent.UserClickedLoginButton);
            if (guestPopupClick) sendGuestPopupLoginClicked(guestPopupClick.source, guestPopupClick.provider);
            StorageWrapper.clearUserState();
            navigateToPage(url);
        };
    }
    // TODO: This file should not be in memebership_incentive folder. Refactor
    constructor(preventClicksOutsideOfPopupFromClosingPopup = false, callbackHash, options){
        super({
            key: 'strings:homePage.header.login'
        }, {
            key: 'strings:colonistCommon.utils.emptyString'
        }, ()=>undefined, ()=>undefined, true);
        this.preventClicksOutsideOfPopupFromClosingPopup = preventClicksOutsideOfPopupFromClosingPopup;
        this.callbackHash = callbackHash !== null && callbackHash !== void 0 ? callbackHash : ViewPopupLogin.getCallbackHashFromUrl();
        var _options_ssoMode;
        this.ssoMode = (_options_ssoMode = options === null || options === void 0 ? void 0 : options.ssoMode) !== null && _options_ssoMode !== void 0 ? _options_ssoMode : false;
        this.onCancel = options === null || options === void 0 ? void 0 : options.onCancel;
        this.popupSource = options === null || options === void 0 ? void 0 : options.popupSource;
        setElementInnerHTML(this.body, {
            key: 'strings:colonistCommon.utils.emptyString'
        });
        this.loginButtonsDiv = ViewPopupLogin.buildLoginPopupBody(this, {
            ssoMode: this.ssoMode
        });
        this.createLoginButtons();
        this.removeFooter();
        this.show();
        if (this.popupSource != null) sendGuestPopupShown(this.popupSource);
    }
}
